module.exports = __webpack_public_path__ + "img/true-wallet.6a8ee9a2.png";